import { render } from "./Gallery.vue?vue&type=template&id=5cac4120"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=5cac4120&lang=css"
script.render = render

export default script